import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    rules: [],
    isCollapse: false
  },
  mutations: {
    switchCollapse(state) {
      state.isCollapse = !state.isCollapse
    },
    INIT_ROLES(state, rules) {
      sessionStorage.setItem('role', JSON.stringify(rules))
      state.rules = rules
    },
    INIT_MENUS(state, menus) {
      state.menus = menus
    }
  },
  actions: {
    // async getRoles(store) {
    //   const res = await fetchRolesList()
    //   store.commit('INIT_ROLES', Object.values(res))
    //   store.commit('INIT_MENUS', Object.values(res))
    // }
  }
})
